import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=279fb5cd&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279fb5cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('279fb5cd')) {
      api.createRecord('279fb5cd', component.options)
    } else {
      api.reload('279fb5cd', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=279fb5cd&scoped=true&", function () {
      api.rerender('279fb5cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HcnCGlfH4h0n/JS/comp/Voucher-Unit.vue"
export default component.exports